module.exports = __webpack_public_path__ + "static/media/deliverytime-icon.8b306a6f.svg";